import React__default, { useEffect } from 'react';
import { travisCIApiRef } from '../api/index.esm.js';
import { useLocalStorage } from 'react-use';

const StateContext = React__default.createContext([]);
const STORAGE_KEY = `${travisCIApiRef.id}.settings`;
const ContextProvider = ({ entity, children }) => {
  const [settings, setSettings] = useLocalStorage(STORAGE_KEY, { entity });
  if (settings === void 0) {
    throw new Error("Firebase functions plugin settings is undefined");
  }
  useEffect(() => {
    if (settings.entity !== entity) {
      setSettings({ entity });
    }
  }, [entity]);
  return /* @__PURE__ */ React__default.createElement(StateContext.Provider, { value: [settings, setSettings] }, /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, children));
};

export { ContextProvider, StateContext };
//# sourceMappingURL=ContextProvider.esm.js.map
